var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-message"},[_c('a',{staticClass:"map-link",style:(`background-image: url(${_vm.imageUrl})`),attrs:{"href":_vm.locationUrl,"target":"_blank"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }